// extracted by mini-css-extract-plugin
module.exports = {"duration":"Duration__duration--3bl","subTitle":"Duration__subTitle--C5L"};